<template>
    <div
        :class="{'form-group':true, 'has-error':error !== ''}"
    >
        <label v-if="label" class="control-label" :for="id">{{ label }}:</label>
        <div class="callout callout-info"
            v-if="hasCalloutInfoSlot"
        >
            <slot name="callout-info"></slot>
        </div>

        <v-select
            :value="value"
            :options="options"
            :label="selectLabel"
            :reduce="reduce"
            @input="onInput"
        ></v-select>

        <small v-if="error === '' && description !== null" class="help-block" v-text="description"></small>
        <span v-if="error !== ''" class="help-block">{{ error }}</span>
    </div>
</template>

<script>

import vSelect from 'vue-select';

export default {

    /*
        Slots:

        - callout-info: <template v-slot:callout-info></template>
     */

    components: {
        vSelect,
    },

    computed: {

        hasCalloutInfoSlot() {
            return !!this.$slots['callout-info'];
        },
    },

    inheritAttrs:false,

    methods:{

        focusField(){
            this.$refs.input.focus()
        },

        onInput(value) {
            this.$emit('input', value);
        },
    },

    mounted() {
        if (this.focus === true) {
            setTimeout(() => this.focusField(), 200);
        }
    },

    props:{
        description:{
            type:String,
            default:null,
        },
        error:{
            type:String,
            default:'',
        },
        focus:{
            type:Boolean,
            default:false,
        },
        id:{
            type:String,
            default(){
                return `select-${this._uid}`
            },
        },
        label:{
            required:true,
            type:String,
        },
        options: {
            required:true,
            type:Array,
        },
        reduce: {
            type: Function,
            default: option => option,
        },
        selectLabel: {
            type:String,
            default:'value',
        },
        value:{
            required:true,
        },
    },
}

</script>
